import * as o from "react";
import t from "../lib/IconBase.es.js";
import m from "../defs/Play.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...e, weights: m }));
a.displayName = "PlayIcon";
const n = a;
export {
  n as Play,
  a as PlayIcon
};
